
import IndexModel from "@/service/v10/sigap/IndexModel"; 

class EnderecoService extends IndexModel { 
      
    constructor() {
        super(); 
        this.url =  this.url + '/Endereco' ;  
    }
 
    public getApiUrl(  ) { 
        return this.getAxios().defaults.baseURL + this.url; 
    }
  
    public getModel( id  ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url + '/' + id    )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
     
    public cadastrarMy(   dados: any ) : Promise<any> { 
        return  new Promise((resolve, reject) => {  
            this.getAxios().post( this.url , dados   )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {   
                reject(error.response);
            }) 
        }); 
    }
 
    public updateMy( id: any , dados: any ) : Promise<any>  { 
        return  new Promise((resolve, reject) => {  
            this.getAxios().put( this.url + '/' +  id   , dados  )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {   
                reject(error.response);
            }) 
        }); 
    }
 
    public excluirMy( id: any ) : Promise<any> { 
        return  new Promise((resolve, reject) => {  
            this.getAxios().delete( this.url + '/' +   id    )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {   
                reject(error.response);
            }) 
        }); 
    }
  
}
  
export default EnderecoService; 